import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggedInUser, LoggedInUserService } from '../../../auth/logged.in.user';
import { CmsDialogDto } from '../../../models/cms.dialogs/cms.dialogs.models';
import { CmsDialogService } from '../../../services/cms.dialog.service';

type HelpAwardsTab = 'overview' | 'matches' | 'search' | 'bookmarks' | 'competitors' | 'foi';

type SubscribedDialogTab = Exclude<HelpAwardsTab, 'foi'>;

@Component({
    selector: 'help-awards',
    template: require('./help.awards.component.html'),
    styles: [require('../personal.account.shared.css'), require('./help.awards.component.css')]
})
export class HelpAwardsComponent implements OnInit, OnDestroy {
    private readonly tabOrder: HelpAwardsTab[] = ['overview', 'matches', 'search', 'bookmarks', 'competitors', 'foi'];
    private readonly dialogPrefixes: Record<SubscribedDialogTab, string> = {
        overview: 'Awards Overview',
        matches: 'Matching Awards Info',
        search: 'Search Awards Info',
        bookmarks: 'Shared Bookmarked Awards Info',
        competitors: 'Competitors Info'
    };

    selectedTabIndex = 0;
    overviewContent = '';
    matchesContent = '';
    searchContent = '';
    bookmarksContent = '';
    competitorsContent = '';
    foiContent = '';

    private subscribed: boolean;
    private loggedInUser: LoggedInUser;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly cmsDialogService: CmsDialogService,
        userService: LoggedInUserService) {
        this.loggedInUser = userService.getCurrentUser();
        this.subscribed = !this.loggedInUser.canAdHoc('notSubscribed');
    }

    ngOnInit() {
        document.body.classList.add('personal-account-fit');

        this.route.queryParams.subscribe(params => {
            const tab = this.normalizeTab((params && params.tab ? params.tab : '').toString());
            this.selectedTabIndex = this.tabOrder.indexOf(tab);
            if (this.selectedTabIndex < 0) {
                this.selectedTabIndex = 0;
            }
        });

        this.loadDialogTab('overview', 'overviewContent');
        this.loadDialogTab('matches', 'matchesContent');
        this.loadDialogTab('search', 'searchContent');
        this.loadDialogTab('bookmarks', 'bookmarksContent');
        this.loadDialogTab('competitors', 'competitorsContent');
        this.loadFoiTab();
    }

    ngOnDestroy() {
        document.body.classList.remove('personal-account-fit');
    }

    onTabChange(index: number) {
        const tab = this.tabOrder[index] || 'overview';
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { tab },
            queryParamsHandling: 'merge',
            replaceUrl: true
        });
    }

    private normalizeTab(tab: string): HelpAwardsTab {
        if (tab === 'overview' || tab === 'matches' || tab === 'search' || tab === 'bookmarks'
            || tab === 'competitors' || tab === 'foi') {
            return tab;
        }
        return 'overview';
    }

    private loadDialogTab(
        tab: SubscribedDialogTab,
        contentField: 'overviewContent' | 'matchesContent' | 'searchContent' | 'bookmarksContent' | 'competitorsContent') {
        const suffix = this.subscribed ? 'Subscribed' : 'Not Subscribed';
        const description = !this.subscribed && tab === 'bookmarks'
            ? 'Bookmarked Awards'
            : !this.subscribed && tab === 'competitors'
                ? 'Competitors'
                : `${this.dialogPrefixes[tab]} - ${suffix}`;

        this.cmsDialogService.getByDescription(description).subscribe((result: CmsDialogDto) => {
            this[contentField] = result.body || '';
        });
    }

    private loadFoiTab() {
        this.cmsDialogService.getByDescription('Resources Info - Subscribed').subscribe((result: CmsDialogDto) => {
            this.foiContent = result.body || '';
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/help/help.awards.component.ts